<template>
    <div>
         <NavBar />
         <LeatherHero />
         <LeatherCategories />
         <FooterPage />
    </div>
</template>

<script>
import NavBar from '../components/NavBar.vue'
import LeatherHero from '../components/LeatherHero.vue'
import LeatherCategories from '../components/LeatherCategories.vue'
import FooterPage from '../components/FooterPage.vue'

export default {
  components: {
    NavBar, LeatherHero, LeatherCategories, FooterPage
  }
}
</script>
